import * as tools from "../../helpers/Tools";
import { logAPI } from "../andyliticsApi";

export const getProcessControlEvents = (token, memId) => {

    const url = encodeURI(tools.buildUrl(tools.ciReplace(tools.hrAPIBaseURL(), "/v1", ""),
        '/ProcessControlEvents/Client/NonExpired/1?eventTypeNames=CombinedPortalMaintenance&eventTypeNames=PortalMaintenance'));

    const params = {
        method: 'post',
        headers: {
            'Authorization': 'bearer ' + token,
            "Content-type": "application/json"
        },
        body: JSON.stringify({
            memberId: memId
        })
    };

    var start = new Date();
    return fetch(url, params).then(response => {
        logAPI("MBHWeb.Api.HealthPlanServices.ProcessControlEvents.GetEvents", start, url);
        if (response && response.status && response.status >= 200 && response.status < 300) {
            return Promise.resolve(response.text().then(function (text) {
                return text ? JSON.parse(text) : []
            }));
        } else {
            return Promise.reject(response);
        }
    }).catch(err => {
        logAPI("MBHWeb.Api.HealthPlanServices.ProcessControlEvents.GetEvents.Failure", start, url, err); return Promise.reject(err);
    });
}

export const getSupportNoticeEvents = (token, memId) => {

    const url = encodeURI(tools.buildUrl(tools.ciReplace(tools.hrAPIBaseURL(), "/v1", ""),
        '/ProcessControlEvents/Client/NonExpired/1?eventTypeNames=SupportNotice'));

    const params = {
        method: 'post',
        headers: {
            'Authorization': 'bearer ' + token,
            "Content-type": "application/json"
        },
        body: JSON.stringify({
            memberId: memId
        })
    };

    var start = new Date();
    return fetch(url, params).then(response => {
        logAPI("MBHWeb.Api.HealthPlanServices.ProcessControlEvents.GetEvents", start, url);
        if (response && response.status && response.status >= 200 && response.status < 300) {
            return Promise.resolve(response.text().then(function (text) {
                return text ? JSON.parse(text) : []
            }));
        } else {
            return Promise.reject(response);
        }
    }).catch(err => {
        logAPI("MBHWeb.Api.HealthPlanServices.ProcessControlEvents.GetEvents.Failure", start, url, err); return Promise.reject(err);
    });
}